import React from 'react';
import { Typography } from "@material-ui/core"
import Form from './Form';
import BtnAntragEinreichen from "./btnEinreichen/BtnAntragEinreichen";
import PageContentArea from '../step/PageContentArea';
import BtnBack from '../step/BtnBack';


const Page: React.FC = () => {
    return (
        <PageContentArea nextBtnVisible={false} backBtnVisible={false}>
            <div>
                <Typography variant='h1' color='textPrimary'>Alles klar, wir sind fast fertig!</Typography>
                <Typography variant='h6' color='textPrimary'>Überprüfen Sie bitte Ihre Kontaktdaten und aktualisieren Sie diese falls notwendig.</Typography>
            </div>
            <div style={{ marginTop: 30 }}>
                <Form />
            </div>
            <div style={{ marginTop: 30, display: 'flex' }}>
                <BtnBack />
                <BtnAntragEinreichen />
            </div>
        </PageContentArea>
    );
}

export default Page;